import { METRICS } from './fields'

export const getMetricsGroupPath = ({ metricsGroupName, isCustomMetric }) => {
  return isCustomMetric ? metricsGroupName : `${METRICS}.${metricsGroupName}`
}
export const getMetricPath = ({ metricsGroupName, metricValue, isCustomMetric }) => {
  return isCustomMetric ? `${metricsGroupName}.${metricValue}` : `${METRICS}.${metricsGroupName}.${metricValue}`
}
